/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import { type Meta, type StoryObj } from '@storybook/react-vite';

import { IconButtonArray } from '../../index';
import {
  IconButtonArrayCollapsible,
  IconButtonArrayCollapsibleSrc,
  IconButtonArrayFloating,
  IconButtonArrayFloatingSrc,
  IconButtonArrayHorizontal,
  IconButtonArrayHorizontalSrc,
  IconButtonArraySizes,
  IconButtonArraySizesSrc,
  IconButtonArrayVertical,
  IconButtonArrayVerticalSrc,
} from '.';

const componentMeta: Meta<typeof IconButtonArray> = {
  title: 'Components/IconButtonArray',
  id: 'components-buttons-icon-array',
  component: IconButtonArray,
  tags: ['docsPage'],
  parameters: {
    controls: { disable: true },
  },
  decorators: [
    (Story) => (
      <div className="n-flex n-justify-center">
        <Story />
      </div>
    ),
  ],
};

export default componentMeta;
type Story = StoryObj<typeof componentMeta>;

export const Horizontal: Story = {
  args: {},
  render: IconButtonArrayHorizontal,
  parameters: {
    docs: {
      source: {
        language: 'tsx',
        type: 'code',
        code: IconButtonArrayHorizontalSrc,
      },
    },
  },
};

export const Vertical: Story = {
  args: {},
  render: IconButtonArrayVertical,
  parameters: {
    docs: {
      source: {
        language: 'tsx',
        type: 'code',
        code: IconButtonArrayVerticalSrc,
      },
    },
  },
};

export const Floating: Story = {
  args: {},
  render: IconButtonArrayFloating,
  parameters: {
    docs: {
      source: {
        language: 'tsx',
        type: 'code',
        code: IconButtonArrayFloatingSrc,
      },
    },
  },
};

export const Collapsiable: Story = {
  args: {},
  render: IconButtonArrayCollapsible,
  parameters: {
    docs: {
      source: {
        language: 'tsx',
        type: 'code',
        code: IconButtonArrayCollapsibleSrc,
      },
    },
  },
};

export const Sizes: Story = {
  args: {},
  render: IconButtonArraySizes,
  parameters: {
    docs: {
      source: {
        language: 'tsx',
        type: 'code',
        code: IconButtonArraySizesSrc,
      },
    },
  },
};
